import { render, staticRenderFns } from "./chip-select.vue?vue&type=template&id=40d82b2b"
import script from "./chip-select.vue?vue&type=script&lang=js"
export * from "./chip-select.vue?vue&type=script&lang=js"
import style0 from "./chip-select.vue?vue&type=style&index=0&id=40d82b2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports